<template lang="pug">
include /@ibkr/lib.common/src/icon/messaging
div(class="pickratings insety-16 border-bottom")
    div
        label(class="bold bond-title fg70") {{ $t('ratings') }}
        ib-button-array
            ib-button(
                class="border-accent",
                :class="selected === '1' ? 'fg-inverse bg-accent' : 'fg-accent bg'",
                @click="choseAll"
            ) {{ $t('all') }}
            ib-button(
                class="border-accent",
                :class="selected === '2' ? 'fg-inverse bg-accent' : 'fg-accent bg'",
                @click="choseHighYield"
            ) {{ $t('high_yield') }}
            ib-button(
                class="border-accent",
                :class="selected === '3' ? 'fg-inverse bg-accent' : 'fg-accent bg'",
                @click="choseInvestGrade"
            ) {{ $t('investment') }}
              span(class="mobile") {{ $t('grade') }}
    ib-col(v-if="inCP" class="xl12 matdate")
        div(class="rate-select")
            div(class="containbox")
                span {{ $t('moodys') }}
                span(class="insetx-16 w40")
                    label(class="insety-8 fs7 fg50") {{ $t('from') }}
                    ib-dropdown(
                        class="inset-8 outset-0",
                        width="100%",
                        name="ratings_moodys_min",
                        v-model="moodyFrom",
                        @change="showMoodyMin",
                        :data="moodys"
                    )
                span(class="insetx-16 w40")
                    label(class="insety-8 fs7 fg50") {{ $t('to') }}
                    ib-dropdown(
                        class="inset-8 outset-0",
                        width="100%",
                        name="ratings_moodys_max",
                        v-model="moodyTo",
                        @change="showMoodyMax",
                        :data="moodys"
                    )
        div(class="insety-4 rate-select")
            div(class="containbox")
                span {{ $t('sp') }}
                span(class="insetx-16 w40")
                    label(class="insety-8 fs7 fg50") {{ $t('from') }}
                    ib-dropdown(
                        class="inset-8 outset-0",
                        width="100%",
                        name="ratings_sandp_min",
                        v-model="spFrom",
                        @change="showSPMin",
                        :data="sp"
                    )
                span(class="insetx-16 w40")
                    label(class="insety-8 fs7 fg50") {{ $t('to') }}
                    ib-dropdown(
                        class="inset-8 outset-0",
                        width="100%",
                        name="ratings_sandp_max",
                        v-model="spTo",
                        @change="showSPMax",
                        :data="sp"
                    )
        div(class="insety-16 rate-relations")
            ib-checkbox(
                v-model="selectRelations[0]",
                :disabled="disableAnd"
            ) {{ $t('show_bonds') }}
            br
            ib-checkbox(
                v-model="selectRelations[1]",
                :disabled="disableXand"
            ) {{ $t('ignore_ratings') }}
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'Ratings',

        mixins: [ mxGb ],

        props: {
            disableAnd: {
                type: Boolean,
                default: false
            },
            disableXand: {
                type: Boolean,
                default: true
            },
        },
        
        data() {
           return {
                moodys: [
                    {id:-1, value: "", label: "N/A", class: "highyld"},
                    {id:0, value: "Aaa", label: "Aaa", class: "investgrd"},
                    {id:1, value: "Aa1", label: "Aa1", class: "investgrd"},
                    {id:2, value: "Aa2", label: "Aa2", class: "investgrd"},
                    {id:3, value: "Aa3", label: "Aa3", class: "investgrd"},
                    {id:4, value: "A1", label: "A1", class: "investgrd"},
                    {id:5, value: "A2", label: "A2", class: "investgrd"},
                    {id:6, value: "A3", label: "A3", class: "investgrd"},
                    {id:7, value: "Baa1", label: "Baa1", class: "investgrd"},
                    {id:8, value: "Baa2", label: "Baa2", class: "investgrd"},
                    {id:9, value: "Baa3", label: "Baa3", class: "investgrd"},
                    {id:10, value: "Ba1", label: "Ba1", class: "highyld"},
                    {id:11, value: "Ba2", label: "Ba2", class: "highyld"},
                    {id:12, value: "Ba3", label: "Ba3", class: "highyld"},
                    {id:13, value: "B1", label: "B1", class: "highyld"},
                    {id:14, value: "B2", label: "B2", class: "highyld"},
                    {id:15, value: "B3", label: "B3", class: "highyld"},
                    {id:16, value: "Caa1", label: "Caa1", class: "highyld"},
                    {id:17, value: "Caa2", label: "Caa2", class: "highyld"},
                    {id:18, value: "Caa3", label: "Caa3", class: "highyld"},
                    {id:19, value: "Ca", label: "Ca", class: "highyld"},
                    {id:20, value: "C", label: "C", class: "highyld"},
                ],
                sp: [
                    {id:-1, value: "", label: "N/A", class: "highyld"},
                    {id:0, value: "AAA", label: "AAA", class: "investgrd"},
                    {id:1, value: "AA+", label: "AA+", class: "investgrd"},
                    {id:2, value: "AA", label: "AA", class: "investgrd"},
                    {id:3, value: "AA-", label: "AA-", class: "investgrd"},
                    {id:4, value: "A+", label: "A+", class: "investgrd"},
                    {id:5, value: "A", label: "A", class: "investgrd"},
                    {id:6, value: "A-", label: "A-", class: "investgrd"},
                    {id:7, value: "BBB+", label: "BBB+", class: "investgrd"},
                    {id:8, value: "BBB", label: "BBB", class: "investgrd"},
                    {id:9, value: "BBB-", label: "BBB-", class: "investgrd"},
                    {id:10, value: "BB+", label: "BB+", class: "highyld"},
                    {id:11, value: "BB", label: "BB", class: "highyld"},
                    {id:12, value: "BB-", label: "BB-", class: "highyld"},
                    {id:13, value: "B+", label: "B+", class: "highyld"},
                    {id:14, value: "B", label: "B", class: "highyld"},
                    {id:15, value: "B-", label: "B-", class: "highyld"},
                    {id:16, value: "CCC+", label: "CCC+", class: "highyld"},
                    {id:17, value: "CCC", label: "CCC", class: "highyld"},
                    {id:18, value: "CCC-", label: "CCC-", class: "highyld"},
                    {id:19, value: "CC", label: "CC", class: "highyld"},
                    {id:20, value: "C", label: "C", class: "highyld"},
                    {id:21, value: "D", label: "D", class: "highyld"},
                ],
                selected: '', //-- the selected tab under 'Ratings': All, High Yield, Investment Grade
                moodyFrom: '',
                moodyTo: '',
                spFrom: '',
                spTo: '',
                selectRelations: [false, false],
           }
        },

        methods: {
            choseAll() {
                this.reset();
            },
            choseHighYield() {
                this.selected = '2';
                this.moodyFrom = 'C';
                this.moodyTo = 'Ba1';
                this.spFrom = 'D';
                this.spTo = 'BB+';
                if (!this.inCP) {
                    this.$emit('ratingType', 'High Yield' );
                }
                this.emitAll();
            },
            choseInvestGrade() {
                this.selected = '3';
                this.moodyFrom = 'Baa3';
                this.moodyTo = 'Aaa';
                this.spFrom = 'BBB-';
                this.spTo = 'AAA';
                if (!this.inCP) {
                    this.$emit('ratingType', 'Investment Grade' );
                }
                this.emitAll();
            },
            showMoodyMin() {
                this.$emit('showMoodymin', this.moodyFrom, this.selectRelations);
            },
            showMoodyMax() {
                this.$emit('showMoodymax', this.moodyTo, this.selectRelations);
            },
            showSPMin() {
                this.$emit('showSpmin', this.spFrom, this.selectRelations);
            },
            showSPMax() {
                this.$emit('showSpmax', this.spTo, this.selectRelations);
            },
            emitAll() {
                this.$emit('showMoodymin', this.moodyFrom);
                this.$emit('showMoodymax', this.moodyTo);
                this.$emit('showSpmin', this.spFrom);
                this.$emit('showSpmax', this.spTo);
                this.$emit('showRateRelation', this.selectRelations);
            },
            reset() {
                this.selected = '1';
                this.moodyFrom = '';
                this.moodyTo = '';
                this.spFrom = '';
                this.spTo = '';
                this.selectRelations = [false, false];
                if (!this.inCP) {
                    this.$emit('ratingType', this.$t('all') );
                }
                this.emitAll();
            },

            selectedRatingTab() {
                if (this.moodyFrom === 'C' && this.moodyTo === 'Ba1' && this.spFrom === 'D' && ['BB+','BB '].includes(this.spTo)) {
                    this.selected = '2';
                } else if (this.moodyFrom === 'Baa3' && this.moodyTo === 'Aaa' && this.spFrom === 'BBB-' && this.spTo === 'AAA') {
                    this.selected = '3';
                } else {
                    this.selected = '1';
                }
            }
        },
        watch: {
            selectRelations: function(val) {
               this.selectRelations = val;
               this.$emit('showRateRelation', this.selectRelations);
            }
        },

        mounted() {
            this.$nextTick(() => {
                this.reset();
                if (this.subFilters) {
                    this.moodyFrom = this.getFilterValue('moodyRatingAbove') || '';
                    this.moodyTo = this.getFilterValue('moodyRatingBelow') || '';
                    this.spFrom = this.getFilterValue('spRatingAbove') || '';
                    this.spTo = this.getFilterValue('spRatingBelow') || '';
                    const relations = this.getFilterValue('ratingsRelation');
                    this.selectRelations = relations === 'xand'? [true, true]
                        : relations === 'and' ? [true, false]
                        : [false, false];
                    this.selectedRatingTab();
                }
                this.emitAll();
            });
        }
    }
</script>

<style lang="less">
.pickratings {
    ._btna {
        border-radius: 5px;
        width: 100%;
        margin: 15px 0;
    }
    ._btn {
        width: 33%;
        vertical-align: top;
        &:after {
            background: white;
        }
        .mobile {
            display: inline;
            margin-left: 2px;
        }
    }
}

.rate-select {
    .containbox {
        > span {
            display: inline-block;
            min-width: 60px;
            select {
                border-radius: 3px;
            }
        }
    }
    .w40 {
        width: 40%;
    }
}

@media (max-width:450px) {
    .pickratings {
        ._btn {
            height: 3rem;
            .mobile {
                display: block;
            }
        }
    }
    .rate-select {
        .containbox {
            > span {
                min-width: 48%;
            }
            > span:first-child {
                display: block;
            }
        }
    }
}
</style>